(function(){
  /* 다른 색 사진은 data-manual-src / data-manual-srcset 로만 들어 있어
     스와치가 눌리기 전에는 한 바이트도 안 받는다 [실측: 목록 카드 lazy 440장].
     그래서 밀기가 시작될 때 빈 칸이 지나간다(흰 깜빡임).
     손이 닿은 «그 카드만» 미리 받아 둔다 — 목록 전체를 미리 받지 않는다. */
  if (window.__mjWarm1) return;
  window.__mjWarm1 = true;

  function warmOne(img){
    if (!img || img.__mjWarmed) return;
    var s  = img.getAttribute('data-manual-src');
    var ss = img.getAttribute('data-manual-srcset');
    if (!s && !ss) return;                 /* 이미 제대로 실린 사진은 건드리지 않는다 */
    img.__mjWarmed = true;
    try {
      var w = new Image();
      var sz = img.getAttribute('sizes');
      if (sz) w.sizes = sz;                /* sizes 를 먼저 줘야 srcset 에서 같은 크기를 고른다 */
      if (ss) w.srcset = ss;
      if (s)  w.src = s;
    } catch (e) {}
  }
  function warmCard(card){
    if (!card || card.__mjWarmedAll) return;
    card.__mjWarmedAll = true;
    var list = card.querySelectorAll('img[data-manual-src], img[data-manual-srcset]');
    for (var i = 0; i < list.length; i++) warmOne(list[i]);
  }
  function onTouch(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('product-block') || t.closest('.product-block');
    if (card) warmCard(card);
  }
  /* 캡처 단계 + passive — 테마의 스와이프 처리보다 먼저, 스크롤은 안 막는다 */
  document.addEventListener('pointerdown', onTouch, {passive: true, capture: true});
  document.addEventListener('touchstart',  onTouch, {passive: true, capture: true});
})();
